// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"be74cb1dbc473f06ff6c","811":"d83d6b0f2f81f334d0b6"}[chunkId] + ".js");